import resolutionHistory from "./resolutionHistory";
import targetedUsers from "./targetedUsers";
import linkLock from "./linkLock";
import notifications from "./notifications";

export default {
  resolutionHistory,
  targetedUsers,
  linkLock,
  notifications,
};
